var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "56px",
    viewBox: "0 0 116 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Search-/-Upload",
    transform: "translate(-402.000000, -131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload-Icon",
    transform: "translate(402.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.987835,31.7092784 C110.029072,32.0989691 112.817526,32.914433 112.824742,33.8453608 C112.824742,35.1602062 107.340206,36.2268041 100.556701,36.2268041 C93.7731959,36.2268041 88.2886598,35.1602062 88.2886598,33.8453608 C88.2886598,32.9606186 90.7696907,32.1898969 94.4529897,31.7785567 C94.2988977,31.5865465 94.2121805,31.3492154 94.2061856,31.1030928 C94.2061856,29.7868041 96.8878351,28.7216495 100.195876,28.7216495 C103.503918,28.7216495 106.185567,29.7868041 106.185567,31.1030928 C106.18157,31.3203498 106.112711,31.5314508 105.987835,31.7092784 Z M109.163093,2.98762887 C113.20433,3.37731959 115.992784,4.19278351 115.988454,5.12371134 C115.988454,6.4385567 110.503918,7.50515464 103.720412,7.50515464 C96.9369072,7.50515464 91.4523711,6.4385567 91.4523711,5.12371134 C91.4523711,4.23896907 93.9334021,3.46824742 97.616701,3.05690722 C97.4667512,2.86341528 97.3841392,2.6262224 97.3814433,2.3814433 C97.3814433,1.06515464 100.063093,-8.43769499e-14 103.371134,-8.43769499e-14 C106.679175,-8.43769499e-14 109.360825,1.06515464 109.360825,2.3814433 C109.356828,2.59870034 109.287969,2.8098013 109.163093,2.98762887 Z M17.6991753,45.9876289 C21.7404124,46.3773196 24.528866,47.1927835 24.5360825,48.1237113 C24.5360825,49.4385567 19.0443299,50.5051546 12.2680412,50.5051546 C5.49175258,50.5051546 -4.97379915e-14,49.4385567 -4.97379915e-14,48.1237113 C-4.97379915e-14,47.2389691 2.48103093,46.4682474 6.1643299,46.0569072 C6.01023786,45.864897 5.92352072,45.6275659 5.91752577,45.3814433 C5.91752577,44.0651546 8.59917526,43 11.9072165,43 C15.2152577,43 17.8969072,44.0651546 17.8969072,45.3814433 C17.8929101,45.5987003 17.824051,45.8098013 17.6991753,45.9876289 Z",
    id: "Cloud",
    fill: "#E67F45",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.688866,26.4195876 C88.617732,16.2125773 79.7414433,8.52268041 68.9426804,8.52268041 C60.362268,8.52268041 52.9653608,13.4039175 49.2661856,20.5020619 C40.3898969,21.3896907 33.4375258,28.9338144 33.4375258,38.1103093 C33.4375258,47.8727835 41.4247423,55.8628866 51.1901031,55.8628866 L89.6540206,55.8628866 C97.7898969,55.8628866 104.447835,49.2049485 104.447835,41.0690722 C104.480278,33.3066319 98.438098,26.873387 90.688866,26.4195876 Z",
    id: "Big-Cloud",
    fill: "#E67F45",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.699371,16.097561 C52.2993761,9.19804878 46.299398,4 38.9999125,4 C33.1999336,4 28.1999518,7.2995122 25.6994732,12.097561 C19.6994951,12.697561 15,17.7970732 15,24 C15,30.5990244 20.3990047,36 26.9999562,36 L52.9998614,36 C58.4993535,36 62.9998249,31.4995122 62.9998249,26 C63.0217547,20.7529149 58.9375088,16.4043104 53.699371,16.097561 Z",
    id: "Small-Cloud",
    fill: "#E67F45",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Arrow",
    fill: "#FFFFFF",
    points: "73.6752577 35.1443299 73.6752577 46.3876289 64.2072165 46.3876289 64.2072165 35.1443299 54.1474227 35.1443299 68.9412371 20.357732 83.7350515 35.1515464"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBig);
export default __webpack_public_path__ + "static/media/upload-icon-big.f131640322a1b09fa4cda5d0483bd7d0.svg";
export { ForwardRef as ReactComponent };